import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import Blockquote from '@tiptap/extension-blockquote';
import Paragraph from '@tiptap/extension-paragraph';
import Heading from '@tiptap/extension-heading';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Image from '@tiptap/extension-image';

// Helper attribute configs for preserving HTML attributes
const styleAttribute = {
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute('style'),
  renderHTML: (attributes: Record<string, string | null>) => {
    if (!attributes.style) return {};
    return { style: attributes.style };
  }
};

const classAttribute = {
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute('class'),
  renderHTML: (attributes: Record<string, string | null>) => {
    if (!attributes.class) return {};
    return { class: attributes.class };
  }
};

const alignAttribute = {
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute('align'),
  renderHTML: (attributes: Record<string, string | null>) => {
    if (!attributes.align) return {};
    return { align: attributes.align };
  }
};

const valignAttribute = {
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute('valign'),
  renderHTML: (attributes: Record<string, string | null>) => {
    if (!attributes.valign) return {};
    return { valign: attributes.valign };
  }
};

// Extended extensions that preserve inline styles for correspondence editing

export const BlockquoteWithStyle = Blockquote.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const ParagraphWithStyle = Paragraph.extend({
  addAttributes() {
    return { ...this.parent?.(), class: classAttribute, style: styleAttribute };
  }
});

export const ImageWithDataAttachmentId = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-attachment-id': {
        default: null,
        parseHTML: element => element.getAttribute('data-attachment-id'),
        renderHTML: attributes => {
          if (!attributes['data-attachment-id']) return {};
          return { 'data-attachment-id': attributes['data-attachment-id'] };
        }
      }
    };
  }
});

export const TableWithStyle = Table.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const TableRowWithStyle = TableRow.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const TableCellWithStyle = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: styleAttribute,
      align: alignAttribute,
      valign: valignAttribute
    };
  }
});

export const TableHeaderWithStyle = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: styleAttribute,
      align: alignAttribute,
      valign: valignAttribute
    };
  }
});

export const HeadingWithStyle = Heading.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const BulletListWithStyle = BulletList.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const OrderedListWithStyle = OrderedList.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});

export const ListItemWithStyle = ListItem.extend({
  addAttributes() {
    return { ...this.parent?.(), style: styleAttribute };
  }
});
